module.exports = __webpack_public_path__ + "ed08bd13e20f50e235b1555e22f9f9b7.jpg";